import { Component } from '@angular/core';

/** The lead paragraph under a heading: body face, secondary colour, a short measure. */
@Component({
  selector: 'p[ppcLead]',
  template: '<ng-content />',
  styleUrl: './lead.css',
})
export class PpcLead {}
